import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Fetches the tools an admin can pick from when creating a simulation.
 * Each tool is `{ name, description, inputSchema, source }` where `source` is
 * `simulation`, `simulation+existing` or `existing` (not yet vetted for
 * simulation use).
 */
const getSimulationToolsCatalog = (callback, errorCallback) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            '/ads/admin/simulations/tools-catalog',
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function')
              callback(response?.data?.tools || []);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to fetch tools catalog');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to fetch tools catalog',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to fetch tools catalog');
    }
  };
};

export default getSimulationToolsCatalog;
